import Flickity from 'flickity-as-nav-for';

const PER_PAGE = 3;
const GROUPED_BY = 2;

export default class {
    constructor (selectorMain, selectorNavigation) {
        this.$wrapper = $(selectorMain);
        this.$wrapperNavigation = $(selectorNavigation);

        this.$images = this.$wrapper.find('.gallery-image');
        this.$navigationImages = this.$wrapperNavigation.find('.gallery-image');
        this.$viewport = null;

        if (this.$images.length === 0) {
            return;
        }

        this.$nextSlideWrapperNavigationButton = null;
        this.$previousSlideWrapperNavigationButton = null;

        this.carousel = new Flickity(this.$wrapper.get(0), {
            fullscreen: true,
            sync: selectorNavigation
        });

        this.carouselNavigation = new Flickity(this.$wrapperNavigation.get(0), {
            asNavFor: this.$wrapper.get(0),
            contain: true,
            groupCells: GROUPED_BY,
            pageDots: this.$images.length > PER_PAGE,
            selectedAttraction: 0.2,
            friction: 0.8,
            sync: selectorMain,
            on: {
                ready: () => this.ready(),
                change: index => this.change(index)
            }
        });
    }

    ready () {
        this.$viewport = this.$wrapperNavigation.find('.flickity-viewport');
        this.pages = Math.floor((this.$images.length + PER_PAGE - 1) / PER_PAGE);

        this.$viewport.addClass('gradient-right');
        this.$displayFullscreenButton = this.$wrapper.find('.flickity-fullscreen-button-view');
        this.$closeFullscreenButton = this.$wrapper.find('.flickity-fullscreen-button-exit');
        this.$nextSlideWrapperNavigationButton = this.$wrapperNavigation.find('.next');
        this.$previousSlideWrapperNavigationButton = this.$wrapperNavigation.find('.previous');
        this.$dots = this.$wrapperNavigation.find('.flickity-page-dots');
        this.$displayFullscreenButton.click(() => this.displayFullscreen());
        this.$closeFullscreenButton.click(() => this.closeFullscreen());
    }

    change (index) {
        switch (true) {
            case index === 0 :
                this.$viewport.removeClass('gradient-left').addClass('gradient-right');
                break;

            case index === this.pages:
                this.$viewport.removeClass('gradient-right').addClass('gradient-left');
                break;

            default:
                this.$viewport.removeClass('gradient-left gradient-right');
        }
    }

    displayFullscreen () {
        this.$dots.css('display', 'none');
        this.$nextSlideWrapperNavigationButton.css('display', 'none');
        this.$previousSlideWrapperNavigationButton.css('display', 'none');
        this.$wrapperNavigation.addClass('is-fullscreen');
        this.carousel.resize();
        this.carouselNavigation.resize();
    }

    closeFullscreen () {
        this.$dots.css('display', 'block');
        this.$nextSlideWrapperNavigationButton.css('display', 'block');
        this.$previousSlideWrapperNavigationButton.css('display', 'block');
        this.$wrapperNavigation.removeClass('is-fullscreen');
        this.carousel.resize();
        this.carouselNavigation.resize();
    }
}
